module.exports = __webpack_public_path__ + "chart-pie.png";